import Bignumber from "./Bignumber";

// @material-ui/core components
import Grid from "@material-ui/core/Grid";

import {
  HourglassEmpty as HourglassEmptyIcon,
  ShoppingCart as ShoppingCartIcon,
  Cached as CachedIcon,
  Description as DescriptionIcon,
  Check as CheckIcon,
  LocalShipping as LocalShippingIcon,
  Store as StoreIcon,
  OpenInBrowser as OpenInBrowserIcon,
} from "@material-ui/icons";

function BignumbersWorkFlowPrateleiraInfinita({ data, onClickLabel }) {
  return (
    <Grid container spacing={2}>
      <Grid
        item
        xs={12}
        sm={6}
        md={4}
        hidden={!data?.AtendimentoAbertos?.Problema}
      >
        <Bignumber
          label="Atendimento aberto"
          icon={ShoppingCartIcon}
          value={data?.AtendimentoAbertos?.TotalPedidosErro}
          onClickLabel={() =>
            onClickLabel(data?.AtendimentoAbertos?.IdPedidoErros)
          }
        />
      </Grid>
      <Grid
        item
        xs={12}
        sm={6}
        md={4}
        hidden={!data?.PedidosIntegrados?.Problema}
      >
        <Bignumber
          label="Pedido Integrado"
          icon={CachedIcon}
          value={data?.PedidosIntegrados?.TotalPedidosErro}
          onClickLabel={() =>
            onClickLabel(data?.PedidosIntegrados?.IdPedidoErros)
          }
        />
      </Grid>
      <Grid item xs={12} sm={6} md={4} hidden={!data?.AguardandoXML?.Problema}>
        <Bignumber
          label="Aguardando XML"
          icon={DescriptionIcon}
          value={data?.AguardandoXML?.TotalPedidosErro}
          onClickLabel={() => onClickLabel(data?.AguardandoXML?.IdPedidoErros)}
        />
      </Grid>
      <Grid
        item
        xs={12}
        sm={6}
        md={4}
        hidden={!data?.AguardandoLogistica?.Problema}
      >
        <Bignumber
          label="Aguardando Logística"
          icon={HourglassEmptyIcon}
          value={data?.AguardandoLogistica?.TotalPedidosErro}
          onClickLabel={() =>
            onClickLabel(data?.AguardandoLogistica?.IdPedidoErros)
          }
        />
      </Grid>
      <Grid item xs={12} sm={6} md={4} hidden={!data?.PedidoAprovado?.Problema}>
        <Bignumber
          label="Pedido Aprovado"
          icon={CheckIcon}
          value={data?.PedidoAprovado?.TotalPedidosErro}
          onClickLabel={() => onClickLabel(data?.PedidoAprovado?.IdPedidoErros)}
        />
      </Grid>
      <Grid
        item
        xs={12}
        sm={6}
        md={4}
        hidden={!data?.AguardandoEmbarque?.Problema}
      >
        <Bignumber
          label="Pedido Aguardando Embarque"
          icon={HourglassEmptyIcon}
          vvalue={data?.AguardandoEmbarque?.TotalPedidosErro}
          onClickLabel={() =>
            onClickLabel(data?.AguardandoEmbarque?.IdPedidoErros)
          }
        />
      </Grid>
      <Grid
        item
        xs={12}
        sm={6}
        md={4}
        hidden={!data?.PedidoEmTransito?.Problema}
      >
        <Bignumber
          label="Pedido em Trânsito"
          icon={LocalShippingIcon}
          value={data?.PedidoEmTransito?.TotalPedidosErro}
          onClickLabel={() =>
            onClickLabel(data?.PedidoEmTransito?.IdPedidoErros)
          }
        />
      </Grid>
      <Grid
        item
        xs={12}
        sm={6}
        md={4}
        hidden={!data?.PedidoEntregueNaLoja?.Problema}
      >
        <Bignumber
          label="Pedido entregue na Loja"
          icon={StoreIcon}
          value={data?.PedidoEntregueNaLoja?.TotalPedidosErro}
          onClickLabel={() =>
            onClickLabel(data?.PedidoEntregueNaLoja?.IdPedidoErros)
          }
        />
      </Grid>
      <Grid
        item
        xs={12}
        sm={6}
        md={4}
        hidden={!data?.PedidoAguardandoRetirada?.Problema}
      >
        <Bignumber
          label="Pedido aguardando retirada"
          icon={OpenInBrowserIcon}
          value={data?.PedidoAguardandoRetirada?.TotalPedidosErro}
          onClickLabel={() =>
            onClickLabel(data?.PedidoAguardandoRetirada?.IdPedidoErros)
          }
        />
      </Grid>
      <Grid
        item
        xs={12}
        sm={6}
        md={4}
        hidden={!data?.PedidoEntregueAoCliente?.Problema}
      >
        <Bignumber
          label="Pedido entregue ao cliente"
          icon={CheckIcon}
          value={data?.PedidoEntregueAoCliente?.TotalPedidosErro}
          onClickLabel={() =>
            onClickLabel(data?.PedidoEntregueAoCliente?.IdPedidoErros)
          }
        />
      </Grid>
      <Grid item xs={12} sm={6} md={4} hidden={!data?.PedidoEntregue?.Problema}>
        <Bignumber
          label="Pedido entregue"
          icon={CheckIcon}
          value={data?.PedidoEntregue?.TotalPedidosErro}
          onClickLabel={() => onClickLabel(data?.PedidoEntregue?.IdPedidoErros)}
        />
      </Grid>
    </Grid>
  );
}

export { BignumbersWorkFlowPrateleiraInfinita };
